export default __webpack_public_path__ + "static/media/Vespa2.c08b6062.jpg";